import FilterLinesIcon from './FilterLinesIcon';

export default FilterLinesIcon;
